import { acquisitionBins, riskBins, volumeBins } from '../constants/gaugeBins';
import { ApiPredictionForType } from 'shared/graphql/generatedApiTypes';
import { cleanStringCase } from 'shared/helpers/formatHelpers';

export const getGaugeProps = ({
  predictionLevel,
  predictionType,
}: {
  predictionLevel: number;
  predictionType: ApiPredictionForType;
}) => {
  switch (predictionType) {
    case ApiPredictionForType.Volume:
      const volumeKeys = Object.keys(volumeBins);
      const selectedVolumeIndex = volumeKeys.indexOf(
        predictionLevel.toString(),
      );
      return {
        topLabel: cleanStringCase(volumeBins[Math.ceil(volumeKeys.length / 2)]),
        chartLabel: 'PURCHASE QUANTITY: THIS QTR VS LAST QTR',
        leftLabel: cleanStringCase(volumeBins[1]),
        rightLabel: cleanStringCase(volumeBins[volumeKeys.length]),
        colorList: [
          '#E02a43',
          '#ED8494',
          '#f6c2c8',
          '#ececec',
          '#c2e0fe',
          '#85c4fd',
          '#2897fc',
        ],
        selectedSectionIndex: selectedVolumeIndex,
        selectedSectionLabel: cleanStringCase(
          volumeBins[selectedVolumeIndex + 1],
        ),
      };
    case ApiPredictionForType.Acquisition:
      const acquisitionKeys = Object.keys(acquisitionBins);
      const selectedAcquisitionIndex = acquisitionKeys.indexOf(
        predictionLevel.toString(),
      );
      return {
        sectionColor: 'rgb(41, 151, 252)',
        topLabel: cleanStringCase(
          acquisitionBins[Math.ceil(acquisitionKeys.length / 2)],
        ),
        chartLabel: 'First Purchase Propensity (This Qtr)',
        leftLabel: cleanStringCase(acquisitionBins[1]),
        rightLabel: cleanStringCase(acquisitionBins[acquisitionKeys.length]),
        numberOfSections: acquisitionKeys.length,
        selectedSectionIndex: selectedAcquisitionIndex,
        selectedSectionLabel: cleanStringCase(
          acquisitionBins[selectedAcquisitionIndex + 1],
        ),
      };
    case ApiPredictionForType.Risk:
      const riskKeys = Object.keys(riskBins);
      const selectedRiskIndex = riskKeys.indexOf(predictionLevel.toString());
      return {
        sectionColor: 'rgb(41, 151, 252)',
        topLabel: cleanStringCase(riskBins[Math.ceil(riskKeys.length / 2)]),
        chartLabel: 'Reorder Propensity (This Qtr)',
        leftLabel: cleanStringCase(riskBins[1]),
        rightLabel: cleanStringCase(riskBins[riskKeys.length]),
        numberOfSections: riskKeys.length,
        selectedSectionIndex: selectedRiskIndex,
        selectedSectionLabel: cleanStringCase(riskBins[selectedRiskIndex + 1]),
      };

    default:
      return null;
  }
};
